import script from "./ThirdPartyIntegrations.vue?vue&type=script&setup=true&lang=js"
export * from "./ThirdPartyIntegrations.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./ThirdPartyIntegrations.vue?vue&type=style&index=1&id=15ea742a&lang=css"

const __exports__ = script;

export default __exports__